module.exports = __webpack_public_path__ + "assets/img/604b-vc.svg";